import axios from 'axios'
import ErrorMessage from './ErrorMessage'
import {
  apiHost
} from "../../config/miniConfig.js";
import { Toast } from 'vant-green';


const axiosInstance = axios.create({
  baseURL: apiHost, //服务器地址
  timeout: 1000 * 60 * 60
})

let platForms = "zhanhui"

// 拦截器（请求拦截）
axiosInstance.interceptors.request.use((config) => {
  
  let token = localStorage.getItem('vtoken')||'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MDQxODYwNjAsInBsYXRmb3JtIjoiemhhbmh1aSIsInVzZXJuYW1lIjoid3hf5YmR5oyH5pyd6ZizNzc3MC42NzcyMjUxNzkyNjkifQ.vCU0iYjAsRYWzjhpY33KsFQQid92hy5A1i0c74UFUXQ'
  // get请求
      // config.headers['X-Litemall-IdentiFication'] = config['params']!=undefined?(config['params']['platForm']!=undefined?config['params']['platForm']:'zhanhui'):'zhanhui'

  if(config.method=='post'){
    config.headers['X-Litemall-IdentiFication'] = config['data']!=undefined?(config['data']['platForm']!=undefined?config['data']['platForm']:'zhanhui'):'zhanhui'
  }else{
    config.headers['X-Litemall-IdentiFication'] = config['params']!=undefined?(config['params']['platForm']!=undefined?config['params']['platForm']:'zhanhui'):'zhanhui'
  }
  
  if (token) {
    config.headers['X-Litemall-Admin-Token'] = token
  }
  return config
})
// 拦截器（响应拦截）
axiosInstance.interceptors.response.use((res) => {
  // Indicator.open()
  if (res.status == 200) {
    let response = res.data
    if (response.errno == 0 || response.errno == true) {
      return Promise.resolve(response)
    }else if(response.errno == -99){
      return Promise.reject(response);
    } else  {
      console.warn(response);
      Toast(response.detailMessage || response.errmsg || response.msg)
      // Indicator.close()
      return Promise.reject(response);
    }
  }
  

}, (err) => {
  // console.log(err.response);
  // console.log(`err.response.data=====${JSON.stringify(err.response.data)}`);
//   Indicator.close()
  return Promise.reject(err);
  // if (err && err.response) {
  // uni.showToast({
  //     title:'操作失败',
  //     icon:'none'
  // })
  // console.log(err.response,'=====================')
  // switch (err.response.data.statusCode) {
  // case 401:location.href=wxentry;break;
  // }
  // }
})

export const get = function (url, params = {}, platForm) {
  platForms = platForm
  // debugger
  return new Promise((resolve, reject) => {
    axiosInstance.get(url, {
      params: params
    }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
      // reject(err.response ? err.response.data : ErrorMessage.timeOut)
    })
  })
}


export const post = function (url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axiosInstance.post(url, params, headers).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
      //   reject(err.response ? err.response.data : ErrorMessage.timeOut)
    })
  })
}
const uploadRequestHeader = {
  headers: {
    "Content-Type": "multipart/form-data"
  }
};
export const upload = function (url, params = {}, ) {
//   Indicator.open("识别中,请稍等~")
  return new Promise((resolve, reject) => {
    axiosInstance.post(url, params, uploadRequestHeader).then((res) => {
      resolve(res.data)
    //   Indicator.close()
    }).catch((err) => {
    //   Indicator.close()
      resolve(err)
      //   reject(err.response ? err.response.data : ErrorMessage.timeOut)
    })
  })
}

export const put = function (url, {
  id,
  params = {}
}) {
  return new Promise((resolve, reject) => {
    let rurl = url
    if (id != undefined && id != '') {
      rurl = url + '/' + id
    }
    axiosInstance.put(rurl, params).then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.response ? err.response.data : ErrorMessage.timeOut)
      })
  })
}


export const deleter = function (url, id, params = {}) {
  return new Promise((resolve, reject) => {
    axiosInstance.delete(url + '/' + id, {
      params
    }).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err.response ? err.response.data : ErrorMessage.timeOut)
    })
  })
}

export const del = function (url, params) {
  return new Promise((resolve, reject) => {
    axiosInstance.delete(url, {
      params
    }).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err.response ? err.response.data : ErrorMessage.timeOut)
    })
  })
}


export const patch = function (url, {
  id,
  params = {}
}) {
  return new Promise((resolve, reject) => {
    console.log(url, id, params)
    let rurl = url
    if (id !== undefined && id !== '') {
      rurl = url + '/' + id
    }
    // console.log(rurl)
    axiosInstance.patch(rurl, params).then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.response ? err.response.data : ErrorMessage.timeOut)
      })
  })
}



// WEBPACK FOOTER //
// ./src/common/js/request.js